export const PB_PAYMENT_DETAILS_SET_PASSENGER_DETAILS_ONWARD =
  'PB_PAYMENT_DETAILS_SET_PASSENGER_DETAILS_ONWARD';
export const PB_PAYMENT_DETAILS_SET_PASSENGER_DETAILS_RETURN =
  'PB_PAYMENT_DETAILS_SET_PASSENGER_DETAILS_RETURN';
export const PB_PAYMENT_DETAILS_SET_CONTACT_DETAILS = 'PB_PAYMENT_DETAILS_SET_CONTACT_DETAILS';
export const PB_PAYMENT_DETAILS_BOOK_TICKET_BEGIN = 'PB_PAYMENT_DETAILS_BOOK_TICKET_BEGIN';
export const PB_PAYMENT_DETAILS_BOOK_TICKET_SUCCESS = 'PB_PAYMENT_DETAILS_BOOK_TICKET_SUCCESS';
export const PB_PAYMENT_DETAILS_BOOK_TICKET_FAILURE = 'PB_PAYMENT_DETAILS_BOOK_TICKET_FAILURE';
export const PB_PAYMENT_DETAILS_BOOK_TICKET_DISMISS_ERROR =
  'PB_PAYMENT_DETAILS_BOOK_TICKET_DISMISS_ERROR';
export const PB_PAYMENT_DETAILS_APPLY_PROMO_CODE_BEGIN =
  'PB_PAYMENT_DETAILS_APPLY_PROMO_CODE_BEGIN';
export const PB_PAYMENT_DETAILS_APPLY_PROMO_CODE_SUCCESS =
  'PB_PAYMENT_DETAILS_APPLY_PROMO_CODE_SUCCESS';
export const PB_PAYMENT_DETAILS_APPLY_PROMO_CODE_FAILURE =
  'PB_PAYMENT_DETAILS_APPLY_PROMO_CODE_FAILURE';
export const PB_PAYMENT_DETAILS_APPLY_PROMO_CODE_DISMISS_ERROR =
  'PB_PAYMENT_DETAILS_APPLY_PROMO_CODE_DISMISS_ERROR';
export const PB_PAYMENT_DETAILS_CHECK_CORPORATE_DISCOUNT_BEGIN =
  'PB_PAYMENT_DETAILS_CHECK_CORPORATE_DISCOUNT_BEGIN';
export const PB_PAYMENT_DETAILS_CHECK_CORPORATE_DISCOUNT_SUCCESS =
  'PB_PAYMENT_DETAILS_CHECK_CORPORATE_DISCOUNT_SUCCESS';
export const PB_PAYMENT_DETAILS_CHECK_CORPORATE_DISCOUNT_FAILURE =
  'PB_PAYMENT_DETAILS_CHECK_CORPORATE_DISCOUNT_FAILURE';
export const PB_PAYMENT_DETAILS_CHECK_CORPORATE_DISCOUNT_DISMISS_ERROR =
  'PB_PAYMENT_DETAILS_CHECK_CORPORATE_DISCOUNT_DISMISS_ERROR';
export const PB_PAYMENT_DETAILS_GET_CONVENIOS_BEGIN = 'PB_PAYMENT_DETAILS_GET_CONVENIOS_BEGIN';
export const PB_PAYMENT_DETAILS_GET_CONVENIOS_SUCCESS = 'PB_PAYMENT_DETAILS_GET_CONVENIOS_SUCCESS';
export const PB_PAYMENT_DETAILS_GET_CONVENIOS_FAILURE = 'PB_PAYMENT_DETAILS_GET_CONVENIOS_FAILURE';
export const PB_PAYMENT_DETAILS_GET_CONVENIOS_DISMISS_ERROR =
  'PB_PAYMENT_DETAILS_GET_CONVENIOS_DISMISS_ERROR';
export const PB_PAYMENT_DETAILS_SET_CONVENIOS = 'PB_PAYMENT_DETAILS_SET_CONVENIOS';
export const RUT_ERROR = 'RUT_ERROR';
export const NAME_ERROR = 'NAME_ERROR';
export const LAST_NAME_ERROR = 'LAST_NAME_ERROR';
export const CONFIRM_EMAIL_ERROR = 'CONFIRM_EMAIL_ERROR';
export const EMAIL_ERROR = 'EMAIL_ERROR';
export const MOBILE_ERROR = 'MOBILE_ERROR';



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusPaymentDetails/redux/constants.js